module.exports = __webpack_public_path__ + "static/media/shared-knowledge-2.bd4fa4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/shared-knowledge-2.png
// module id = 1000
// module chunks = 21